<template>
  <div class="thankyouPage page">
    
    <div class="columns">
      <div class="column">
        <div class="breadcrumb">
          <router-link to="/">KK</router-link> - <router-link :to="{ name: 'ThankyouPage' }">Danke</router-link>
          <h1>Vielen Dank</h1>
          <p>Wir werden Ihre Bestellung für den {{deliverydate}} nun bearbeiten</p>
          
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  export default {
    name: 'ThankyouPage',
    data: function(){
      return {
         }
    },
    created: function(){
        this.user.basket = [];
        const basket = this.user.basket;
        const { dispatch } = this.$store;
        dispatch('basket/update', { basket });
        
    },
    mounted: function(){},
    computed: {
       user () {
            return this.$store.state.authentication.user
        },  
        lastOrder () {
            console.log(this.$store.state.orders);
            return this.$store.state.orders.lastOrder;
        },
        deliverydate (){
          var d = new Date(  this.$store.state.orders.lastOrder.deliverydate )
          return d.toLocaleDateString();
        }
    }
}
</script>
<style>
</style>